import React, { ReactNode } from 'react'
import { BasicStyledComponent, DSFieldSlider, DSRangeValue } from 'shared-definitions/types'
import styles from './FieldSlider.module.css'
import clsx from 'clsx'
import RangeInputDiscovery from './RangeInputDiscovery'

interface Value {
  min: number
  max: number
}

interface FieldSliderProps extends BasicStyledComponent {
  field: DSFieldSlider
  onChange: (value: Value) => void
  onDynamicChange?: (value: Value) => void
  value: Value
  renderMinDotLabel?: (value: DSRangeValue) => ReactNode
  renderMaxDotLabel?: (value: DSRangeValue) => ReactNode
}

export const FieldSlider: React.FC<FieldSliderProps> = ({
  onChange,
  value,
  field,
  className,
  renderMaxDotLabel,
  renderMinDotLabel,
  onDynamicChange,
}) => (
  <div className={clsx(className, styles.container)}>
    <RangeInputDiscovery
      renderMaxDotLabel={renderMaxDotLabel}
      renderMinDotLabel={renderMinDotLabel}
      variant="compact"
      className={styles.slider}
      constraints={field}
      value={value}
      onChange={onChange}
      onDynamicChange={onDynamicChange}
    />
  </div>
)
